import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import { DropdownService } from './dropdown.service';
import { Subscription } from 'rxjs';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ag-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass],
})
export class DropdownComponent implements OnInit, OnDestroy {
  private dropdownService = inject(DropdownService);

  @Input()
  isActive = false;

  @Input()
  isRightAligned = false;

  @Input()
  isSmall = false;

  @Input()
  isHoverable = false;

  onClickSubscription: Subscription;

  constructor() {}

  ngOnInit() {
    this.onClickSubscription = this.dropdownService.onClick.subscribe(
      (dropdown) => {
        if (dropdown !== this) {
          this.isActive = false;
        }
      },
    );
  }

  ngOnDestroy(): void {
    this.onClickSubscription.unsubscribe();
  }

  blur() {
    this.isActive = false;
  }

  toggle(event: Event) {
    event.stopPropagation();
    event.preventDefault();
    this.isActive = !this.isActive;
    this.dropdownService.emit(this);
  }
}
